import request from '@/utils/request'
export const getMenu = data => {
  return request.get('/masterdata-api/adfs/query/menu', data)
}
export const routerAdfs = data => {
  return request.get('/masterdata-api/adfs/login', data)
}
